import React from "react";
import BackgroundDiv from "../misc/elements/BackgroundDiv";
import ArrayInfo from "./ArrayInfo";
import RelatedView from "./RelatedView";
import DetailedAttached from "./DetailedAttached";
import DetailedButton from "./DetailedButton";
import DetailedDescription from "./DetailedDescription";
import DetailedGlobalActivitiy from "./DetailedGlobalActivitiy";
import DetailedImageBar from "./DetailedImageBar";
import DetailedMoods from "./DetailedMoods";
import DetailedNumberHolder from "./DetailedNumberHolder";
import DetailedPointsBar from "./DetailedPointsBar";
import DetailedRatingHolder from "./DetailedRatingHolder";
import MainStore from "../stores/MainStore";

const DetailedFieldHolder = ({ fieldObject, type }) => {
  const { player } = MainStore();
  return (
    <div
      className="divRow"
      style={{
        width: "100%",
        justifyContent: "center",
        alignItems: "start",
        flex: fieldObject.field == "relatedView" ? 1 : null,
        marginBottom: fieldObject.field == "relatedView" ? "40px" : "10px",
      }}
    >
      {fieldObject.field == "points" && (
        <DetailedPointsBar points={fieldObject.payload.points} />
      )}
      {fieldObject.field == "rating" && (
        <DetailedRatingHolder
          field={fieldObject.payload.field}
          onClick={fieldObject.payload.onClick}
          rating={fieldObject.payload.rating}
          name={fieldObject.payload.name}
          icon={fieldObject.payload.icon}
          type={type}
        />
      )}
      {fieldObject.field == "relatedView" && (
        <RelatedView
          array={fieldObject.payload.array}
          name={fieldObject.payload.name}
          type={fieldObject.payload.type}
          onClick={fieldObject.payload.onClick}
        />
      )}
      {fieldObject.field == "detailedNumber" && (
        <DetailedNumberHolder
          boolean={fieldObject.payload.boolean}
          name={fieldObject.payload.name}
          ending={fieldObject.payload.ending}
          icon={fieldObject.payload.icon}
        />
      )}
      {fieldObject.field == "globalActivity" && (
        <DetailedGlobalActivitiy
          active={fieldObject.payload.active}
          open={fieldObject.payload.open}
          saved={fieldObject.payload.saved}
          description={fieldObject.payload.description}
        />
      )}
      {fieldObject.field == "detailedButton" && (
        <DetailedButton
          description={fieldObject.payload.description}
          onButtonClicked={fieldObject.payload.onClick}
          image={fieldObject.payload.image}
          name={fieldObject.payload.name}
          fontSize={17}
          player={player}
          activeButton={fieldObject.payload.activeButton}
          id={fieldObject.payload.id}
          player={player}
          boxType={fieldObject.payload.boxType}
          backgroundColor={"#3f3f3f"}
        />
      )}
      {fieldObject.field == "images" && (
        <DetailedImageBar
          description={fieldObject.payload.description}
          images={fieldObject.payload.images}
          onImageClicked={fieldObject.payload.onClick}
        />
      )}
      {fieldObject.field == "arrayInfo" && (
        <div className="divColumn" style={{ width: "80%", cursor: "pointer" }}>
          <div
            className="divRow"
            style={{
              width: "50%",
              position: "relative",
              justifyContent: "center",
              padding: "5px",
            }}
          >
            <BackgroundDiv
              backgroundColor={"#4f4f4f"}
              opacity={0.8}
              borderBottom={true}
            />
            <div className="textBold" style={{ zIndex: 1 }}>
              {fieldObject.payload.description}
            </div>
          </div>
          <div
            className="divRow"
            style={{
              width: "53%",
              position: "relative",
              justifyContent: "center",
              height: "100%",
              paddingBottom: "5px",
            }}
          >
            <img
              src={fieldObject.payload.icon}
              className="icon25"
              style={{ zIndex: 1 }}
            />
            <BackgroundDiv backgroundColor={"#8f8f8f"} borderTop={true} />
            <div style={{ zIndex: 1 }}>
              <ArrayInfo
                textColor="white"
                objectArray={fieldObject.payload.objectArray}
                values={fieldObject.payload.values}
              />
            </div>
            {fieldObject.payload.arrayAmount && (
              <div
                className="divColumn"
                style={{ zIndex: 1, width: "100px", height: "34px" }}
              >
                <div className="textWhite">
                  {fieldObject.payload.objectArray.length}
                </div>
                <div
                  className="textWhite"
                  style={{
                    marginBottom: "2px",
                    fontSize: "14px",
                    color: "#1f1f1f",
                  }}
                >
                  {fieldObject.payload.arrayAmount}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {fieldObject.field == "description" && (
        <DetailedDescription description={fieldObject.payload.description} />
      )}
      {fieldObject.field == "moods" && (
        <div className="divRow" style={{ width: "90%" }}>
          <DetailedMoods moodObject={fieldObject.payload.moodObject} />
        </div>
      )}
      {fieldObject.field == "attached" && (
        <DetailedAttached
          statements={fieldObject.payload.statements}
          thoughts={fieldObject.payload.thoughts}
          focuses={fieldObject.payload.focuses}
          reports={fieldObject.payload.reports}
        />
      )}
    </div>
  );
};

export default DetailedFieldHolder;
